<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{$t("boxScan.title")}}
      </div>
      <div class="btn-group pull-right">
        <el-button :plain="true" size="mini" v-if="canScan" class="sm-hidden" @click="beginScan">{{ $t("boxScan.beginScan") }}
          <i class="fa fa-qrcode"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">

      <el-table border stripe :data="scanInfos" size="mini" class="customer-table">
        <el-table-column v-if="canDelete" align="center" :resizable="true" :label="this.$t('operation')">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteScanInfo(scope.row.BoxNumber)" :disabled="scope.row.CompleteIWAC">{{$t('delete')}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="BoxNumber" align="center" :resizable="true" :label="this.$t('boxScan.boxNumber')">
        </el-table-column>
        <el-table-column prop="ScanUserName" align="center" :resizable="true" :label="this.$t('boxScan.scanUserName')">
        </el-table-column>
        <el-table-column prop="DeliveryScanTime" align="center" :resizable="true" :label="this.$t('boxScan.deliveryScanTime')" :formatter="timeFormatter">
        </el-table-column>
        <el-table-column align="center" :resizable="true" :label="this.$t('boxScan.completeIWAC')">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.CompleteIWAC" type="success">已导入</el-tag>
            <el-tag v-else type="warning">未导入</el-tag>

          </template>
        </el-table-column>
      </el-table>

      <el-row class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>

      <!-- search dialog -->
      <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible">
        <el-form class="search-form" :model="filter" :inline="true" size="small" label-width="70px">
          <el-form-item :label="this.$t('boxScan.boxNumber')" size="small">
            <el-input v-model="filter.boxNumber"></el-input>
          </el-form-item>
          <el-form-item :label="this.$t('boxScan.scanUserName')" size="small">
            <el-input v-model="filter.scanUserName"></el-input>
          </el-form-item>

          <el-form-item :label="this.$t('boxScan.deliveryScanTime')" size="small">
            <el-date-picker v-model="filter.startScanTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="this.$t('to')" size="small">
            <el-date-picker v-model="filter.endScanTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="this.$t('boxScan.completeIWAC')" size="small" label-width="110px">
            <el-radio v-model="filter.completeIWAC" label="true">已导入</el-radio>
            <el-radio v-model="filter.completeIWAC" label="false">未导入</el-radio>
            <el-radio v-model="filter.completeIWAC" label="all">所有</el-radio>
          </el-form-item>
        </el-form>

        <div slot="footer" class="search-footer">
          <el-button @click="searchDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
          <el-button @click="resetFilter" :plain="true" size="mini">{{this.$t('reset')}}</el-button>
          <el-button type="primary" @click="search" :plain="true" size="mini">{{this.$t('confirm')}}</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";
import fileSaver from "file-saver";
import { mapGetters } from "vuex";
export default {
  name: "BoxScan",
  data() {
    return {
      searchDialogVisible: false,
      scanInfos: [],
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      loading: false,
      filter: {
        completeIWAC: "all"
      },
      filterOptions: []
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getScanInfos();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getScanInfos();
    },
    getScanInfos() {
      this.loading = true;
      let params = {
        filter: JSON.stringify(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios
        .get("api/delivery/boxscan", { params })
        .then(res => {
          this.totalCount = res.data.TotalCount;
          this.scanInfos = res.data.Data;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      searchHistoryService.setHistory(
        searchTypes.SCANBOX_HISTORY,
        this.filterOptions
      );
      this.getScanInfos();
    },
    resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.SCANBOX_HISTORY);
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh() {
      this.resetFilter();
      this.getScanInfos();
    },
    initializeFilter() {
      let his = searchHistoryService.getHistory(searchTypes.SCANBOX_HISTORY);
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    beginScan() {
      this.$router.push({ name: "ScanInfo" });
    },
    deleteScanInfo(boxNumber) {
      this.$confirm(
        this.$t("boxScan.deleteScanInfoConfirm", { boxNumber: boxNumber }),
        this.$t("tip"),
        {
          type: "warning"
        }
      )
        .then(resp => {
          this.$axios
            .delete(`api/delivery/boxscan/boxnumber/${boxNumber}`)
            .then(resp => {
              this.$message({
                type: "success",
                message: this.$t("deleteSuccess")
              });
              this.getScanInfos();
            })
            .catch(e => {
              let msg =
                (e.response && e.response.data) || this.$t("deleteFail");
              this.$message({
                type: "error",
                message: msg
              });
            });
        })
        .catch(() => {});
    }
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    canDelete() {
      return this.permissions.find(p => p.toLowerCase() === "boxscan.delete");
    },
    canScan() {
      return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(p => p.toLowerCase() === "boxscan.insert")
      );
    }
  },
  created() {
    this.initializeFilter();
    this.getScanInfos();
  }
};
</script>

<style lang="scss">

</style>









// WEBPACK FOOTER //
// src/components/application/BoxScan/BoxScan.vue